import { createSelector } from 'reselect';
import { WORKFLOWS_DOMAIN } from './constants';
import { initialState } from './reducer';

const selectWorkflowsDomain = state => state[WORKFLOWS_DOMAIN] || initialState;

export const selectWorkflowsFilter = () => createSelector(selectWorkflowsDomain, d => d.filter);

export const selectItemsCount = () => createSelector(selectWorkflowsDomain, d => d.itemsCount);

export const selectWorkflow = workflowId => createSelector(selectWorkflowsDomain, d => d.workflowsById[workflowId]);

export const selectWorkflows = () => createSelector(selectWorkflowsDomain, d => d.workflows);

export const selectPaginator = () => createSelector(selectWorkflowsDomain, d => d.paginator);

export const selectWorkflowProduct = () => createSelector(selectWorkflowsDomain, d => d.workflowProduct);

export const selectCompanyWorkflow = () => createSelector(selectWorkflowsDomain, d => d.companyWorkflow);
